export default __webpack_public_path__ + "img/component-info-2.e6b50f33.png";